import { Button, Select } from 'antd'
import { useState } from 'react'

import { InfoCircleOutlined } from '@ant-design/icons'
import TextArea from 'antd/es/input/TextArea'
import { useParams } from 'react-router-dom'
import { TERMINATION_REASONS } from '../../../Types'
import { useTerminateSubject } from '../../../hooks/useSubject'

export const TerminateSubjectDrawer = ({ subject, onClose = () => {} }) => {
  const { projectId, siteId } = useParams() as { projectId: string; siteId: string }

  const [disqualificationType, setDisqualificationType] = useState<TERMINATION_REASONS>()
  const [disqualificationReason, setDisqualificationReason] = useState('')

  const { callTerminate, isLoading } = useTerminateSubject(projectId, subject._id, siteId)

  const resetState = () => {
    setDisqualificationType(undefined)
    setDisqualificationReason('')
    onClose()
  }

  const handleTerminate = () => {
    const obj = {
      projectId: projectId,
      subjectId: subject._id,
      reasonType: disqualificationType,
      reasonDescription: disqualificationReason,
    }

    return callTerminate(obj)
      .then(() => {
        resetState()
      })
      .catch((error) => {
        alert(error.message)
      })
  }
  return (
    <div className="container-fluid h-100 d-flex flex-column">
      <div className="d-flex align-items-center mb-3">
        <InfoCircleOutlined style={{ color: '#dc3545', fontSize: 22, marginRight: 8 }} />
        <h5 style={{ margin: 0 }}>Confirm Study Termination</h5>
      </div>

      <p className="mt-3">
        Please select the reason for termination for the audit trail. The subject’s device will be automatically
        disabled, stopping all data collection.
      </p>

      <p className="mb-0 opacity-75 mt-4 mb-1 p-small">Termination reason</p>
      <Select
        placeholder="Reason"
        onChange={(value) => setDisqualificationType(value)}
        value={disqualificationType}
        options={[
          { value: TERMINATION_REASONS.DISCONTINUED, label: 'Discontinued' },
          { value: TERMINATION_REASONS.SCREEN_FAILURE, label: 'Screen failure' },
          { value: TERMINATION_REASONS.OTHER, label: 'Other' },
        ]}
        className="me-2 w-100"
      />

      <p className="mb-0 opacity-75 mt-4 mb-1 p-small">Provide justification</p>
      <TextArea
        placeholder="Justification for study termination"
        rows={2}
        className=""
        value={disqualificationReason}
        onChange={(e) => setDisqualificationReason(e.target.value)}
      />

      <div style={{ marginTop: 24, textAlign: 'right' }}>
        <Button onClick={resetState}>Cancel</Button>
        <Button
          className="ms-2"
          type="primary"
          danger
          loading={isLoading}
          onClick={handleTerminate}
          disabled={!disqualificationType}
        >
          Confirm Termination
        </Button>
      </div>
    </div>
  )
}
